export default (props, traits) => {
  return {
    form: {
      submit: {
        display: 'inline-block',
        width: 'auto'
      }
    },

    label: {
      fontSize: 'inherit',
      fontWeight: 'inherit',
      display: 'inline',
      '& p': {
        display: 'inline'
      }
    }
  }
}
